import { useCookies } from 'react-cookie'

export function useUserAuthorized(): boolean {
    const [cookies] = useCookies()

    if (cookies.token) return true
    return false
}
